<template>
  <v-card style="margin: 0;padding: 0;">
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex>

          <v-textarea v-model="model.source" outline :label="dic.source.text" auto-grow></v-textarea>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<style scoped>

</style>

<script>
  import OtherProperty from "./otherProperty.ts";
  export default OtherProperty;
</script>